<breadcrumb [paginas]="[{ route: '/home', name: 'Home' },{ route: '/consulta-ponto', name: 'Consulta Entrada e Saída das Escola'}]"/>

<app-filtro-padrao (filtroEmitter)="searchHandler($event)" [template]="2" [style]="1"></app-filtro-padrao>

<!-- TITULO -->
<section class="section-saudacao">
  <div class="container">
    <h2 class="titulo-page">Consulta Entrada e Saída das Escola</h2>

    <app-btn-back class="btn_voltar_consulta"></app-btn-back>
  </div>
</section>

<section class="section-grid-consulta-ponto">

  <div class="container">

    <div class="row_registros">
      <h3>Registro de Entrada e Saída</h3>
        <a
         *ngIf="this.userLogado?.codigoPerfil == 1634 || this.userLogado?.codigoPerfil == 1477"
          class="btn_adicionar_registro"
          href="javascript:void(0)"
          (click)="abrirModalInserirRegistro()">
          <i aria-hidden="true" class="fa fa-plus"></i>
        </a>
    </div>

    <h3 class="sub-titulo-dash">Listagem de apontamento</h3>

    <app-tabulator-table
      [filtros]="filtrosTabela"
      [columnNames]="colunasGrid"
      [tipoRelatorio]="2"
      [tableData]="jornadas"
      [orientacaoPortrait]="false"
    >
    </app-tabulator-table>
  </div>
</section>

<app-modal class="modal-overlay" *ngIf="modalAjustePonto && this.userLogado?.codigoPerfil != 1656">
  <form [formGroup]="form" (submit)="ajustarPonto()">
    <!-- Header do Modal -->
    <div class="modal-header">
      <div class="titulo-modal">
        <h2>Solicitação de ajuste de entrada/saída</h2>
      </div>
      <button class="btn-fechar-modal" (click)="closeModalAjustePonto()">
        ✖
      </button>
    </div>
    <!-- Corpo do Modal -->
    <div class="modal-body">
      <div class="row-escola">
        <img
          src="../../../assets/img/icons/icon-calendario.svg"
          title="Calendario"
          alt=""
        />
        <p><b>Data: </b>{{ jornadaAtiva?.dataEntrada }}</p>
      </div>
      <div class="row-escola">
        <img
          src="../../../assets/img/icons/icon-nome-escola.svg"
          title="Polo e URE"
          alt=""
        />
        <p><b>Polo/ URE:</b> {{ jornadaAtiva?.poloDiretoria }}</p>
      </div>
      <div class="row-escola">
        <img
          src="../../../assets/img/icons/icon-nome-escola.svg"
          title="Escala"
          alt=""
        />
        <p><b>Escola:</b> {{ jornadaAtiva?.escolaFormatada }}</p>
      </div>

      <hr />

      <div class="grup_input">
        <label for="story">Justificação da Solicitação</label>
        <textarea
          id="story"
          name="story"
          rows="5"
          cols="33"
          formControlName="justificativa"
        ></textarea>

        @if(formControls.justificativa.errors && formControls.justificativa.touched){
          <div class="alert"> Campo obrigatório </div>
          }
      </div>

      <div class="grup_input_duplo">
        <div class="input">
          <label for=""
            >Selecione o Tipo de Registro e Informe a Hora correta:</label
          >
          <select formControlName="tipoRegistro"
            [class.alert]="form.get('tipoRegistro')?.errors"
          >
            <option value="" disabled selected >
              Selecione o tipo de Registro
            </option>
            <option value="1">Entrada</option>
            <option value="2">Saída</option>
          </select>

          @if(formControls.tipoRegistro.errors){
          <div class="alert"> Campo obrigatório </div>
          }
        </div>
        <div class="input">
          <label for="story">Hora de Saída</label>
          <input type="time" id="story" name="story" formControlName="hora" />
          @if(formControls.hora.errors &&
          formControls.hora.touched){
            <div class="alert"> Campo obrigatório </div>
            }
        </div>
      </div>
    </div>
    <!-- Footer do Modal -->
    <div class="modal-footer">
      <button class="btn_segundario" (click)="closeModalAjustePonto()">
        Fechar
      </button>
      <button class="btn_primeiro" type="submit">Ajustar</button>
    </div>
  </form>
</app-modal>

<app-modal class="modal-overlay" *ngIf="modalInserirPonto && this.userLogado?.codigoPerfil != 1656">
  <form [formGroup]="formInserir" (submit)="inserirJornada()">
    <!-- Header do Modal -->
    <div class="modal-header">
      <div class="titulo-modal">
        <h2>Inserir Jornada Antiga</h2>
      </div>
      <button class="btn-fechar-modal" (click)="closeModalInserirPonto()">
        ✖
      </button>
    </div>
    <!-- Corpo do Modal -->
    <div class="modal-body">
      <div class="conteudo-select">
          <label for="select-gravidade">Data e Hora do Check-In: </label>
          <input
          type="datetime-local"
          name="horaEntrada"
          class="input-date"
          formControlName="horaEntrada"
          aria-label="Hora do Check-In"
          />
        </div>

        <div class="conteudo-select">
          <label for="horaSaida">Hora do Check-Out:</label>
          <input
            type="time"
            id="horaSaida"
            name="horaSaida"
            class="input-time"
            formControlName="horaSaida"
            aria-label="Hora do Check-Out"
          />
        </div>

        <div class="grupo-filter">
          <p><b>URE</b></p>
          <ng-select
            [items]="diretorias"
            bindLabel="nomeDiretoria"
            bindValue="codigoDiretoria"
            placeholder="Selecione uma URE"
            formControlName="codigoDiretoria"
            (change)="getEscolas()"
            aria-describedby="diretoria-error"
          >
          </ng-select>
        </div>

        <div class="grupo-filter">
          <p><b>Escola</b></p>
          <ng-select
            [items]="escolas"
            bindLabel="nomeEscola"
            bindValue="codigoEscola"
            placeholder="Selecione uma Escola"
            formControlName="codigoEscola"
            name="codigoEscola"
            aria-describedby="escolas-polo-error">
          </ng-select>
        </div>

      <div class="grup_input">
        <label for="story">Justificação da Solicitação</label>
        <textarea
          id="story"
          name="story"
          rows="5"
          cols="33"
          formControlName="justificativa"
        ></textarea>
      </div>
    </div>
    <!-- Footer do Modal -->
    <div class="modal-footer">
      <button class="btn_segundario" (click)="closeModalInserirPonto()">
        Fechar
      </button>
      <button class="btn_primeiro" type="submit">Inserir</button>
    </div>
  </form>
</app-modal>
